export default "__VITE_ASSET__DzNoK8SB__"